var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var $ijazI$react = require("react");
var $ijazI$radixuireactusecallbackref = require("@radix-ui/react-use-callback-ref");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "useControllableState", function () {
  return $b84d42d44371bff7$export$6f32135080cb4c3;
});
function $b84d42d44371bff7$export$6f32135080cb4c3(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _$b84d42d44371bff7$va = $b84d42d44371bff7$var$useUncontrolledState({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _$b84d42d44371bff7$va2 = _slicedToArray(_$b84d42d44371bff7$va, 2),
    uncontrolledProp = _$b84d42d44371bff7$va2[0],
    setUncontrolledProp = _$b84d42d44371bff7$va2[1];
  var isControlled = prop !== undefined;
  var value1 = isControlled ? prop : uncontrolledProp;
  var handleChange = $ijazI$radixuireactusecallbackref.useCallbackRef(onChange);
  var setValue = $ijazI$react.useCallback(function (nextValue) {
    if (isControlled) {
      var setter = nextValue;
      var value = typeof nextValue === 'function' ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [isControlled, prop, setUncontrolledProp, handleChange]);
  return [value1, setValue];
}
function $b84d42d44371bff7$var$useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var uncontrolledState = $ijazI$react.useState(defaultProp);
  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
    value = _uncontrolledState[0];
  var prevValueRef = $ijazI$react.useRef(value);
  var handleChange = $ijazI$radixuireactusecallbackref.useCallbackRef(onChange);
  $ijazI$react.useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}